import axios from "axios";

export default {
  namespaced: true,

  state: () => ({
    courses: [],
    combinations: []
  }),

  mutations: {
    courses(state, courses) {
      state.courses = courses || [];
    },

    combinations(state, combinations) {
      state.combinations = combinations || [];
    }
  },

  actions: {
    getCourses({ commit }) {
      // Get all site courses
      axios.get("/courses").then(response => {
        commit("courses", response.data.courses);
        return response;
      });
    },

    async getCoursesCombinations({ commit }) {
      return axios.get("/courses/combinations").then(response => {
        commit("combinations", response.data.combinations);
        return response;
      });
    }
  },

  getters: {
    selectCourseCombinationData: state => {
      return state.courses.map(c => {
        return {
          id: c.id,
          title: c.title,
          code: c.code
        };
      });
    }
  },

  modules: {}
};
